export const getUrl = state => state.url.get('url')

export const getPrevUrl = state => state.url.get('prevUrl')
